import { createFileRoute } from "@tanstack/react-router";
import { TeamcenterBridge } from "@/components/views/teamcenter/TeamcenterBridge";

export const Route = createFileRoute("/teamcenter")({
  component: TeamcenterBridge,
});
